let instance = null;
const enforcer = Symbol('colorManagerEnforcer');

export class ColorManager {
    _hash = {};

    /**
     * Constructor
     *
     * @param {symbol} enforcer  singleton enforcer
     */
    constructor(_enforcer = enforcer) {
        if (_enforcer !== enforcer) {
            throw new Error(`Instantiation failed: use ColorManager.instance`);
        }
        this._hash = {};
    }

    /**
     * @return {ColorManager}
     */
    static get instance() {
        if (!instance) {
            instance = new ColorManager();
        }
        return instance;
    }

    /**
     *
     * @param {string} value
     * @return {boolean}
     */
    static isConstant(value) {
        return value.match(/^%color#[^%]+%$/) !== null;
    }

    /**
     * @param {string} value
     * @return {string}
     */
    interpolate(value) {
        return value.replace(/%color#([^%]+)%/g, (token, key) => this.getValue(key) ?? token);
    }

    /**
     * Return key value or key if no value found
     *
     * @param {string} key  key
     * @return {any} value
     */
    getValue(key) {
        if (typeof key !== 'string' || !this._hash[key]) {
            return null;
        }
        return this._hash[key].value;
    }

    /**
     * Set the constants hash
     *
     * @param {Record<string, any>} hash
     */
    setHash(hash = {}) {
        this._hash = Object.fromEntries(
            Object.entries(hash).map(([key, value]) => [
                key,
                {
                    ...value,
                    id: `%color#${key}%`
                }
            ])
        );
    }

    /**
     * Return the constants hash
     *
     * @return {Record<string, any>}
     */
    getHash() {
        return this._hash;
    }
}
